import react from 'react';
import { Link } from 'react-router-dom';
// import { HashLink } from 'react-router-hash-link';
  import'../css/navbar.css';
 function Navbar() {
  return (
    
         <nav class="navbar navbar-expand-lg bg-light sticky-top" id="navbar">
          <div class="container-fluid" >              
    <Link class="navbar-brand  " to="/">
    <img src="/assets/adtlogo.png" alt="apex data technologies" width="250" height="80" class=" "/>
    </Link>
    <button class="navbar-toggler " type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="true" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon color-white"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item   px-2 active ">
        {/* <Link  class="nav-link active text-black  fs-4 fw-bold  font-monospace" to="/">Home</Link>  */}
        <a href="#home" class="nav-link active text-black  fs-4   ">Home</a>
       
        </li>       
        <li class="nav-item  px-2">
        {/* <Link class="nav-link active text-black  fs-4 fw-bold  font-monospace" to="/services">Services</Link>   */}
        <a href="#Services" class="nav-link active text-black  fs-4  ">Services</a>
        </li>
        <li class="nav-item  px-2">
        {/* <Link class="nav-link active text-black  fs-4 fw-bold  font-monospace" to="/about">About</Link>  */}
        <a href="#about" class="nav-link active text-black  fs-4   ">About</a>
        </li>
        <li class="nav-item  px-2">
        {/* <Link class="nav-link active text-black  fs-4 fw-bold  font-monospace" to="/team">Team</Link> */}
        <a href="#team" class="nav-link active text-black  fs-4   ">Team</a> 
        </li>
        <li class="nav-item px-2">
          {/* <Link class="nav-link active text-black  fs-4 fw-bold  font-monospace" to="/contact">Contact Us</Link>  */}
          <a href="#contact" class="nav-link active text-black  fs-4  ">Contact Us</a>
        </li>
      </ul>
    
    </div>
    </div>
  </nav>
 
 
  )
}
export default Navbar;